import { type PropsWithChildren, useCallback, useEffect } from "react";

import { broadcast_logout, close, type LogoutMessage, open } from "./broadcast.ts";

export const BroadcastLogoutProxy = ({ children, onLogout }: PropsWithChildren<{ onLogout: () => void }>) => {
  const handleMessage = useCallback(
    (event: MessageEvent<LogoutMessage>) => {
      if (event.data.logout === true) {
        onLogout();
      }

      if (event.data.reload === true) {
        window.location.reload();
      }
    },
    [onLogout],
  );

  useEffect(() => {
    open();
    broadcast_logout?.addEventListener("message", handleMessage);

    return () => {
      broadcast_logout?.removeEventListener("message", handleMessage);
      close();
    };
  }, [handleMessage]);

  return children;
};
